const lazy = (slider) => {
    slider.on('slideChanged', () => {
        slider.container.querySelectorAll('img').forEach((img) => {
            img.removeAttribute('loading');
        });
    });
};

export default lazy;
